import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoWallet } from '../../../shared/models/appscripts-crypto.model';
import { AppscriptsCryptoService } from '../../../shared/services/appscripts-crypto.service';
import { BrowserUtils } from '../../../shared/services/browser-utils';
import { ModalService } from '../../../shared/services/modal.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { ValidationService } from '../../../shared/services/validation.service';

interface UiWallet {
  loading: boolean;
  wallet: CryptoWallet;
}
type Wallets = 'ltc' | 'btc';

@Component({
  standalone: false,
  selector: 'app-appscripts-crypto-wallet-index',
  templateUrl: 'appscripts-crypto-wallet-index.component.html',
  styleUrls: ['appscripts-crypto-wallet-index.component.scss'],
})
export class AppscriptsCryptoWalletIndexComponent implements OnInit {
  btc: UiWallet = {
    loading: false,
    wallet: null,
  };

  ltc: UiWallet = {
    loading: false,
    wallet: null,
  };

  constructor(
    public service: AppscriptsCryptoService,
    public router: Router,
    public notificationService: NotificationService,
    public validationService: ValidationService,
    public modal: ModalService,
    forBuilder: FormBuilder,
    titleService: Title
  ) {
    //titleService.setTitle('Crypto wallets');
  }

  ngOnInit() {
    this.update('btc');
    this.update('ltc');
  }

  update(name: Wallets) {
    const wallet = this.getWallet(name);
    wallet.loading = true;
    this.fetchWallet(name).subscribe({
      next: cryptoWallet => {
        wallet.loading = false;
        wallet.wallet = cryptoWallet;
      },
      error: err => {
        wallet.loading = false;
      },
    });
  }

  copyToBuffer(content: string) {
    BrowserUtils.copyToClipboard(content);
    this.notificationService.success('Data was copied to the clipboard', 'Copy');
  }

  private fetchWallet(name: Wallets): Observable<CryptoWallet> {
    switch (name) {
      case 'btc':
        return this.service.btcWallet();
      case 'ltc':
        return this.service.ltcWallet();
    }
  }

  private getWallet(name: Wallets): UiWallet {
    switch (name) {
      case 'btc':
        return this.btc;
      case 'ltc':
        return this.ltc;
    }
  }
}
